/**
 * @module @anydo/analytics-react/test-utils
 */

export * from "./AnalyticsProviderNoop";
